















































import { Component, Vue } from 'vue-property-decorator';
import hexabaseState from '@/store/hexabase';
import userState from '@/store/user';
import {
  customerOptionalForm,
  customerDepartmentRegisterHeader,
  CustomerDepartmentOptionalForm
} from '@/constants/form/customerForm';
import {
  registerFinishText,
  registerFinishAction,
  authorityValidMessage,
  authorityInvalidMessage,
  toolTipsMessage
} from '@/constants/customer/customerdepartment';
import {
  FieldChildrenProp,
  ActionFieldSeeting,
  GetInputFieldsActons
} from '@/services/hexabase/types';
import { customerDepartmentRules } from '@/constants/form/inputCheck';

import Customer from '@/models/customerDepartmentModel';

import Header from '@/components/common/modules/Header.vue';
import Icon from '@/components/common/elements/Icon.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';
import SampleAction from '@/components/sample/detail/SampleAction.vue';
import CreateBasicInfoPlusInfo from '@/components/customer/detail/CreateBasicInfoPlusInfo.vue';
import TransitionDialog from '@/components/common/modules/TransitionDialog.vue';
import Dialog from '@/components/common/modules/Dialog.vue';
import ExecAction from '@/components/common/modules/ExecAction.vue';
import { DateTime } from 'luxon';

import HeaderPanel from '@/components/common/modules/HeaderPanel.vue';

interface SelectOptions {
  option_id: string;
  sort_id: 0;
  value: string;
  enabled: true;
  color: string;
  display_id: string;
  text: string;
}

@Component({
  components: {
    Header,
    Icon,
    SideMenu,
    PageInfoBar,
    SampleAction,
    CreateBasicInfoPlusInfo,
    TransitionDialog,
    Dialog,
    HeaderPanel,
    ExecAction
  }
})
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
export default class CustomerDepartmentRegister extends Vue {
  private projectId = hexabaseState.applicationId;
  private customer = new Customer();
  private headerData = { cols: {}, datas: {} as { [k: string]: any } };

  // 各入力フィールド情報格納プロパティ
  private basicFieldsData: Array<FieldChildrenProp> = [];
  private basicFieldCols = '';
  private detailFieldsData: Array<Array<FieldChildrenProp>> = [];

  // dbID格納プロパティ
  private mainDsId = '';
  private customerDsId = '';

  // 受け渡されたアイテムID
  private passedItemId = this.$route.params.id;

  // 登録用情報格納プロパティ
  private registData: any = {
    item: {},
    return_item_result: true, // true指定すると、登録されたアイテム情報を返します
    related_ds_items: {} // 関連するデータストアの新規・更新・削除を指定  詳細は以下を参照
  };
  private registFieldType: any = {};

  // アイテム登録後ダイアログ
  private dialogStatus = false;
  private isLoading = false;
  private registerText = this.customer.deepCopy(registerFinishText);
  private buttons: Array<{ [k: string]: string | number }> = this.customer.deepCopy(
    registerFinishAction
  );

  // APIレスポンス
  private customerBasicInformatioResult: any = [];

  // ステータス
  private displayStatus = '';

  private registAuthority = false;
  private guideMessage = '';

  private basicNewAction: any = [];

  private ActionButtonType = 'register_cancel';
  private toolTipsText = '';

  private referencHeadOfficeJudgmentFlagDepartment = '';
  private defaultOption: SelectOptions = {
    option_id: '',
    sort_id: 0,
    value: '',
    enabled: true,
    color: '',
    display_id: '',
    text: ''
  };

  async created() {
    try {
      // ローディングをセット
      this.$store.commit('hexabase/setIsLoading', true);
      this.mainDsId = hexabaseState.datastoreIds['顧客部署マスタ'];
      this.customerDsId = hexabaseState.datastoreIds['顧客マスタ'];
      // tooltips情報を後設定出来るよう修正
      this.toolTipsText = this.customer.deepCopy(
        toolTipsMessage['customerDepartment_CreateBasicInfoPlusInfo']
      );
      // ステート表示表示は行わない
      this.displayStatus = '';

      // 入力フィールド情報を取得
      await this.getBasicFields();

      // 権限を取得する
      // デフォルトの新規登録アクション以外を取得できていないなら発注登録権限を持たない
      this.registAuthority = this.basicNewAction !== undefined ? true : false;
      this.guideMessage = this.registAuthority ? authorityValidMessage : authorityInvalidMessage;

      //本社拠点判定フラグに対して「拠点部署」のコード値を初期セット
      this.$set(
        this.registData.item,
        'head_office_judgment_flag',
        this.referencHeadOfficeJudgmentFlagDepartment
      );
      this.$set(this.registData.item, 'customer_id', this.passedItemId);
    } catch (e) {
      console.log(e);
      this.setError(e);
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  /**
   * 基本情報入力フォームを生成するための設定情報を取得・整形します
   */
  private async getBasicFields() {
    try {
      const [customerBasicInformatioResult, fieldsData, newAction] = await Promise.all([
        this.customer.getItemDetails(
          hexabaseState.applicationId,
          this.customerDsId,
          this.passedItemId,
          'use_display_id=true'
        ),
        this.customer.makeFieldsList(this.projectId, this.mainDsId),
        this.customer.getNewActionList(this.mainDsId).then(data => {
          return data;
        })
      ]);

      this.basicNewAction = newAction.actions.find(
        v => v.display_id === 'customer_department_register'
      );

      const [inputFields] = await Promise.all([
        this.customer.getFieldsByActionId(this.mainDsId, newAction.actions[0].action_id),
      ]);
      // Create header field
      this.customerBasicInformatioResult = customerBasicInformatioResult;
      this.headerData = await this.getHeaderFields(customerDepartmentRegisterHeader);
      const cheaderData = {
        0: this.customerBasicInformatioResult.field_values['customer_id']['value'],
        1: this.customerBasicInformatioResult.field_values['customer_name']['value'],
        2: this.customerBasicInformatioResult.field_values['telephone_number']['value']
      } as { [key: string]: any };
      // Get&set header data
      this.getHeaderData(cheaderData, this.headerData);

      // 拠点部署の項目IDを退避
      const index_rhojfd = fieldsData.findIndex(v => v.display_id === 'head_office_judgment_flag');
      const wk_rhojfd: any = fieldsData[index_rhojfd];
      const head_office_judgment_flag_option: Array<SelectOptions> =
        wk_rhojfd.options || this.defaultOption;
      this.referencHeadOfficeJudgmentFlagDepartment =
        head_office_judgment_flag_option.find(V => V.text === '拠点部署')?.option_id || '';

      // データ登録時の為各フィールドのデータ型を格納
      for (const key in inputFields.action_fields) {
        this.registFieldType[inputFields.action_fields[key].display_id] =
          inputFields.action_fields[key].dataType;
      }
      const data = this.customer
        .addOptionalFormField(
          fieldsData.filter(v => v.dataType !== 'status'),
          this.customer.deepCopy(CustomerDepartmentOptionalForm),
          true
        )
        .map(field => this.customer.inputRestriction(field, inputFields))
        .map(field => {
          // フィールドの初期値・登録データ初期値
          this.registData.item = {
            ...this.registData.item,
            ...this.customer.setRregistData(field, inputFields)
          };
          return this.customer.setSelected(field, inputFields);
        })
        .map(v => {
          if (v.registProps !== undefined && v.registProps!['setting'] !== undefined) {
            const stateKey = v.registProps!['setting']!.key!;
            switch (stateKey) {
              case 'getUserDepartmentId': {
                v.props!.value = { item_id: userState.getUserDepartmentId };
                break;
              }
              case 'getUserEmployeeId': {
                v.props!.value = { item_id: userState.getUserEmployeeId };
                break;
              }
              case 'getOrderApplicationDate': {
                v.props!.value = DateTime.local().toString();
                break;
              }
              default:
                break;
            }
          }
          return v;
        });
      this.basicFieldCols = this.customer.getGridStatus(data);
      this.basicFieldsData = (await this.modifyFields(
        this.mainDsId,
        data,
        inputFields,
        'customerdepart_regist'
      )) as Array<FieldChildrenProp>;
    } catch (error) {
      console.log(error);
      this.setError(error);
    }
  }

  /**
   * ヘッダ情報フィールド定義作成
   */
  private async getHeaderFields(formData: any) {
    const baseData = {
      cols: {},
      datas: {} as { [k: string]: any }
    };
    try {
      baseData.cols = this.customer.getGridStatus(formData);
      baseData.datas = formData;
    } catch (errorMessage) {
      this.setError(errorMessage);
    }
    return baseData;
  }

  /**
   * ヘッダ情報フィールドデータ作成
   */
  private getHeaderData(setData: { [key: string]: any }, baseData: any) {
    try {
      Object.keys(setData).map((key: string) => {
        baseData.datas[key].props['value'] = setData[key];
      });
    } catch (errorMessage) {
      this.setError(errorMessage);
    }
  }

  /**
   * 子コンポーネントからEmitされる値インサート用に加工（基本情報）
   * 主にPropsの変更を行う
   * @module catchInputBasic
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void}
   */
  private catchInputBasic(response: any) {
    const index = this.basicFieldsData.findIndex(v => v.display_id === response.name);
    switch (this.basicFieldsData[index].component) {
      case 'MasterSelectControl':
      case 'MasterSelectSetControl':
      case 'MasterSelectMultiControl':
      case 'MasterSelectMultiSetControl':
        this.$set(this.basicFieldsData[index].props!, 'value', { item_id: response.value });
        break;
      default:
        this.$set(this.basicFieldsData[index].props!, 'value', response.value);
    }

    // 入力に紐付け入力チェックがある場合
    if (
      customerDepartmentRules.customerdepart_regist.customerdepart_regist !== undefined &&
      customerDepartmentRules.customerdepart_regist.customerdepart_regist !== undefined
    ) {
      const validateRules = this.customer.addLinkingRuleByInput(
        customerDepartmentRules.customerdepart_regist.customerdepart_regist,
        response,
        this.basicFieldsData
      );
      if (validateRules.length > 0) {
        for (const ruleIndex in validateRules) {
          this.$set(
            this.basicFieldsData[validateRules[ruleIndex].key].props!,
            'rules',
            validateRules[ruleIndex].rules
          );
        }
      }
    }
  }

  /**
   * ルーター設定ファイルよりパンくずリスト取得
   * @module getBreadCrumbs
   * @return {array} - breadcrumbs 情報
   */
  private getBreadCrumbs(): [] {
    if (this.$route.matched.some(obj => obj.meta.breadcrumbs)) {
      return this.$route.meta.breadcrumbs;
    }
    return [];
  }

  /**
   * 基本情報パネルで入力された値を受け取り登録データに渡す
   * @public response - インサート用に整形されたデータ
   * @returns void
   */
  private createBasicData(response: any): void {
    this.registData.item = response;
  }

  /**
   * アクションパネルのボタンを押下した際の次処理を進める
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private async execAction(type: any) {
    switch (type) {
      case 'register': {
        try {
          // ローディングをセット
          this.$store.commit('hexabase/setIsLoading', true);
          Object.keys(this.registData.item).forEach(key => {
            const dataType = this.registFieldType[key];
            switch (dataType) {
              case 'number':
                this.registData.item[key] = Number(this.registData.item[key]);
                break;
            }
          });
          // 親画面からリンク作成を行う
          this.$set(this.registData.related_ds_items, this.customerDsId, [
            {
              operation: 11,
              link_to_parent: true,
              i_id: this.passedItemId
            }
          ]);
          // 顧客部署番号（システム付番）をセット
          const autoNumber = await this.customer.getAutoNumber(
            this.projectId,
            this.mainDsId,
            'id',
            this.customerBasicInformatioResult.field_values['customer_id']['value'] ? {
              branch_key: `${this.customerBasicInformatioResult.field_values['customer_id']['value']}-`,
              zero_padding: 'true',
              digit: '3'
            } : {}
          );
          this.$set(this.registData.item, 'department_id', autoNumber.result.value);

          const result = await this.customer.registerLinkedItems(
            hexabaseState.applicationId,
            this.mainDsId,
            this.registData
          );
          this.customer.apiErrorHandle('CREATEITEM', result);
          this.registerText = this.customer.deepCopy(registerFinishText);
          this.buttons.map(v => {
            if (v.name === 'toEdit') {
              v.route = String(v.route).replace(':id', result.item_id);
            }
          });
        } catch (e) {
          console.log(e);
          this.registerText = 'エラーにより処理できませんでした';
          this.buttons.splice(0);
          this.buttons.push({ id: 1, type: 'cancel', name: 'cancel', value: '閉じる' });
        } finally {
          this.$store.commit('hexabase/setIsLoading', false);
          this.dialogStatus = true;
        }
        break;
      }
      case 'cancel': {
        window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
      }
    }
  }

  /**
   * アイテムを登録後ダイアログ表示等を初期化します
   * @returns {void} - 内部プロパティ変更
   */
  private registerFinish(): void {
    this.dialogStatus = false;
    this.isLoading = false;
  }

  async modifyFields(
    dbId: string,
    data: Array<FieldChildrenProp> | Array<FieldChildrenProp[]>,
    inputFields: GetInputFieldsActons,
    type: string
  ) {
    data = this.addInputRules(
      data as Array<FieldChildrenProp>,
      inputFields.action_field_settings,
      type
    );
    return this.modifyInputAllow(data, inputFields.action_field_settings) as Array<
      FieldChildrenProp
    >;
  }

  addInputRules(
    fields: Array<FieldChildrenProp>,
    fieldSetting: { [k: string]: ActionFieldSeeting },
    type: string
  ) {
    return fields.map(field => {
      if (field.props === undefined) return field;

      const ruleArray = [];

      // Hexa側設定必須項目
      if (fieldSetting[field.field_id] !== undefined) {
        // 必須項目確認
        if (fieldSetting[field.field_id].mandatory) {
          const requiredName = field.component === 'SelectArea' ? 'selectRequired' : 'required';
          ruleArray.push(requiredName);
        }
      }

      // アプリ側設定項目
      if (
        customerDepartmentRules.customerdepart_regist !== undefined &&
        customerDepartmentRules.customerdepart_regist[type] !== undefined
      ) {
        const row = customerDepartmentRules.customerdepart_regist[type].find(
          val => val.id === field.display_id
        );
        if (row !== undefined) {
          ruleArray.push(row.rule);
        }
      }

      if (field.props!['rules'] === undefined) {
        field.props!['rules'] = '';
      }
      if (ruleArray.length > 0) field.props!['rules'] = ruleArray.join('|');
      return field;
    });
  }

  modifyInputAllow(
    fields: Array<FieldChildrenProp>,
    fieldSetting: { [k: string]: ActionFieldSeeting }
  ) {
    return fields.map(field => {
      if (fieldSetting[field.field_id] !== undefined) {
        // eslint-disable-next-line prefer-const
        let row = fieldSetting[field.field_id];
        if (row.update && !field.props!.isDisabled) {
          field.props! = { ...field.props!, ...{ isDisabled: false, isReadonly: false } };
        }
        if (field.dataType === 'dslookup') {
          field.props!.isBtnVisible = true;
          field.props!.isLeftSideInputReadOnly = false;
        }
        field = {
          ...field,
          ...{
            show: row.show,
            update: row.update,
            mandatory: row.mandatory
          }
        };
      }
      return field;
    });
  }

  private setError(errorMessage: any) {
    if (typeof errorMessage === 'object') errorMessage = this.customer.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit('hexabase/setIsError', true);
    this.$store.commit('hexabase/setErrorMessage', errorMessage);
  }
}
